import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './PrintNode.frontend.types'

@Injectable({ providedIn: 'root' })
export class PrintNode_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public PrintNode: PrintNode_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
